/**
 * @generated SignedSource<<a25a4f4ae3f2ddc0f8680deb13a89c53>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type sourcesPage_SyncStatusQuery$variables = Record<PropertyKey, never>;
export type sourcesPage_SyncStatusQuery$data = {
  readonly qboSyncStatus: {
    readonly currentObject: string | null | undefined;
    readonly errorMessage: string | null | undefined;
    readonly finishedAt: any | null | undefined;
    readonly mode: string;
    readonly phase: string | null | undefined;
    readonly rowsProcessed: number;
    readonly rowsTotal: number | null | undefined;
    readonly status: string;
    readonly tieOut: ReadonlyArray<{
      readonly asOf: string | null | undefined;
      readonly computed: number;
      readonly delta: number;
      readonly name: string | null | undefined;
      readonly qboAccountId: string;
      readonly reported: number;
    }>;
  } | null | undefined;
};
export type sourcesPage_SyncStatusQuery = {
  response: sourcesPage_SyncStatusQuery$data;
  variables: sourcesPage_SyncStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mode",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phase",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowsProcessed",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowsTotal",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentObject",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finishedAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorMessage",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qboAccountId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "computed",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reported",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "delta",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "asOf",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "sourcesPage_SyncStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QboSyncRun",
        "kind": "LinkedField",
        "name": "qboSyncStatus",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "QboTieOutRow",
            "kind": "LinkedField",
            "name": "tieOut",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "sourcesPage_SyncStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QboSyncRun",
        "kind": "LinkedField",
        "name": "qboSyncStatus",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "QboTieOutRow",
            "kind": "LinkedField",
            "name": "tieOut",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          (v14/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0b8b892c7cdd9b832229477fd32a5482",
    "id": null,
    "metadata": {},
    "name": "sourcesPage_SyncStatusQuery",
    "operationKind": "query",
    "text": "query sourcesPage_SyncStatusQuery {\n  qboSyncStatus {\n    status\n    mode\n    phase\n    rowsProcessed\n    rowsTotal\n    currentObject\n    finishedAt\n    errorMessage\n    tieOut {\n      qboAccountId\n      name\n      computed\n      reported\n      delta\n      asOf\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "167455e200d8e24352c495f2fb598060";

export default node;
